import React, { useEffect, useState } from "react";
import api from "@/lib/api";

const ROWS = {
  marketplace: [["sessions", "Sessions"], ["search_start", "Search starts"], ["provider_view", "Provider views"], ["service_view", "Service views"], ["deal_view", "Deals viewed"],
    ["requests_started", "Requests started"], ["bookings", "Bookings"], ["conversion_rate", "Conversion rate", "%"], ["revenue", "Revenue", "$"]],
  request: [["sessions", "Sessions"], ["ai_request", "AI requests"], ["category_select", "Category selections"], ["requests_started", "Requests started"],
    ["requests_completed", "Requests completed"], ["estimates_received", "Estimates received"], ["bookings", "Bookings"], ["conversion_rate", "Conversion rate", "%"], ["revenue", "Revenue", "$"]],
};
const fmt = (v, unit) => unit === "$" ? `$${Number(v || 0).toLocaleString(undefined, { maximumFractionDigits: 0 })}` : unit === "%" ? `${v || 0}%` : Number(v || 0).toLocaleString();
const nice = (s) => String(s || "direct").replace(/_/g, " ");

export default function AdminHomepageAnalyticsPage() {
  const [days, setDays] = useState(30);
  const [d, setD] = useState(null);
  useEffect(() => { setD(null); api.get("/admin/analytics/homepage", { params: { days } }).then((r) => setD(r.data)).catch(() => setD({ variants: {}, sources: [] })); }, [days]);

  return (
    <div className="max-w-6xl" data-testid="homepage-analytics-page">
      <div className="flex items-end justify-between gap-4 flex-wrap">
        <div>
          <div className="text-xs font-bold tracking-[0.2em] uppercase text-[#165a71]">Analytics</div>
          <h1 className="mt-2 font-display text-3xl md:text-4xl font-semibold text-[#071b22]">Homepage Performance</h1>
        </div>
        <div className="flex gap-1 rounded-full bg-slate-100 p-1" data-testid="homepage-analytics-range">
          {[7, 30, 90].map((n) => <button key={n} onClick={() => setDays(n)} className={`rounded-full px-4 py-1.5 text-sm ${days === n ? "bg-white shadow-sm font-semibold text-[#071b22]" : "text-slate-500"}`} data-testid={`range-${n}`}>{n} days</button>)}
        </div>
      </div>
      {!d ? <div className="mt-10 text-slate-500">Loading…</div> : (
        <>
          <div className="mt-8 grid gap-5 md:grid-cols-2">
            {[["marketplace", "Marketplace Homepage"], ["request", "Request-First Homepage"]].map(([k, label]) => (
              <div key={k} className="rounded-3xl border border-slate-200 bg-white p-6" data-testid={`analytics-card-${k}`}>
                <div className="font-display text-lg font-semibold text-[#071b22]">{label}</div>
                <dl className="mt-4 divide-y divide-slate-100">
                  {ROWS[k].map(([key, lbl, unit]) => (
                    <div key={key} className="flex items-center justify-between py-2.5 text-sm">
                      <dt className="text-slate-500">{lbl}</dt>
                      <dd className="font-semibold tabular-nums text-[#071b22]" data-testid={`metric-${k}-${key}`}>{fmt(d.variants?.[k]?.[key], unit)}</dd>
                    </div>
                  ))}
                </dl>
              </div>
            ))}
          </div>
          <div className="mt-6 rounded-3xl border border-slate-200 bg-white overflow-hidden" data-testid="analytics-sources">
            <div className="px-6 pt-5 pb-3 font-display text-lg font-semibold text-[#071b22]">Request source attribution</div>
            <table className="w-full text-sm">
              <thead><tr className="text-left text-[11px] uppercase tracking-wider text-slate-400 border-y border-slate-100"><th className="px-6 py-3">Source</th><th className="px-3 py-3">Homepage</th><th className="px-3 py-3">Requests</th><th className="px-3 py-3">Submitted</th><th className="px-6 py-3">Bookings</th></tr></thead>
              <tbody>
                {(d.sources || []).length === 0 && <tr><td colSpan={5} className="px-6 py-8 text-center text-slate-400">No requests in this period yet.</td></tr>}
                {(d.sources || []).map((r, i) => (
                  <tr key={i} className="border-t border-slate-50" data-testid={`source-row-${r.source}-${r.variant || "none"}`}>
                    <td className="px-6 py-3 capitalize text-[#071b22]">{nice(r.source)}</td><td className="px-3 py-3 capitalize text-slate-500">{r.variant ? (r.variant === "request" ? "Request-First" : "Marketplace") : "—"}</td>
                    <td className="px-3 py-3 tabular-nums">{r.requests}</td><td className="px-3 py-3 tabular-nums">{r.submitted}</td><td className="px-6 py-3 tabular-nums">{r.bookings}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
}
